/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable no-console */
import { toast } from 'react-toastify';
import { Storage } from 'aws-amplify';
import { generateThumbnailFromVideo, configureStore, newNewsFeedUploadFiles, getVideoDuration } from '../../../../../../../../libs/HelperContent';
import { CreateVideoPayload, createVideoCollection, updateVideo, VideoResponse } from '../../../../../../../actions/video_management/video_management';

// Define types for the thumbnail generation result
interface ThumbnailGenerationResult {
  thumbnailFile: File;
  width?: number;
  height?: number;
}

interface VideoUploadOptions {
//   visibility?: 'public' | 'private';
  categoryIds?: string[];
  tags?: string[];
  title?: string;
  description?: string;
  allowDownload?: boolean;
  allowShare?: boolean;
//   accessControl?: {
//     internalEmployees?: {
//       allSelected?: boolean;
//       departments?: Array<{name: string; count?: number}>;
//       specificUsers?: Array<{userId: string; name: string; email: string; role?: string}>;
//     };
//     userGroups?: Array<{type: string; count?: number}>;
//     participantCount?: number;
//     participantLimit?: number;
//   };
  onProgress?: (progress: number) => void;
}

interface VideoUpdateOptions {
  videoId: string;
  title?: string;
  description?: string;
//   visibility?: 'public' | 'private';
  categoryIds?: string[];
  tags?: string[];
  url?: string; // URL passed directly instead of uploading
  fileType?: string; // File type passed directly
  fileSize?: number; // File size passed directly
  thumbnail?:any // Thumbnail URL passed directly instead of uploading
  playlists?: Array<{
    playlistId: string;
    orderInPlaylist: number;
  }>;
  status?: string; // Status of the video (published, draft, scheduled)
  scheduledPublishDate?: string; // Date for scheduled publishing
  scheduledPublishTime?: string; // Time for scheduled publishing
  scheduledDateTime?: string; // Combined date and time for scheduled publishing
  publishDate?: string; // Publish date for compatibility
  allowDownload?: boolean; // Whether downloading is allowed
  allowShare?: boolean; // Whether sharing is allowed
//   accessControl?: {
//     internalEmployees?: {
//       allSelected?: boolean;
//       departments?: Array<{name: string; count?: number}>;
//       specificUsers?: Array<{userId: string; name: string; email: string; role?: string}>;
//     };
//     userGroups?: Array<{type: string; count?: number}>;
//     participantCount?: number;
//     participantLimit?: number;
//   };
  onProgress?: (progress: number) => void;
}

// New interface for YouTube video upload
interface YouTubeVideoData {
	videoUrl: string;
	videoId: string;
	thumbnailUrl: string;
	title?: string;
	description?: string;
	// visibility?: 'public' | 'private';
	categoryIds?: string[];
	tags?: string[];
	allowDownload?: boolean;
	allowShare?: boolean;
	// accessControl?: {
	// 	internalEmployees?: {
	// 		allSelected?: boolean;
	// 		departments?: Array<{name: string; count?: number}>;
	// 		specificUsers?: Array<{userId: string; name: string; email: string; role?: string}>;
	// 	};
	// 	userGroups?: Array<{type: string; count?: number}>;
	// 	participantCount?: number;
	// 	participantLimit?: number;
	// };
}

/**
 * Validates a video file for upload
 * @param file - The file to validate
 * @returns Object with validation result and error message if any
 */
const validateVideoFile = (file: File): { isValid: boolean; errorMessage?: string } =>
{
	// Validate file type (only mp4, akv allowed)
	const validTypes = [ 'video/mp4', 'video/x-akv', 'video/akv' ];

	if (!validTypes.includes(file.type))
	{
		return {
			isValid      : false,
			errorMessage : `Invalid file type: ${file.type}. Only MP4 and AKV formats are supported.`
		};
	}

	// Validate file size (max 500MB)
	const maxSize = 500 * 1024 * 1024; // 500MB in bytes

	if (file.size > maxSize)
	{
		return {
			isValid      : false,
			errorMessage : `File too large: ${(file.size / (1024 * 1024)).toFixed(2)}MB. Maximum size is 500MB.`
		};
	}

	return { isValid: true };
};

/**
 * Specialized function for uploading YouTube videos without requiring file upload
 * @param companyId - The company ID
 * @param videoData - YouTube video data including URL, videoId, and thumbnail URL
 * @returns Promise with the created video response
 */
export const handleYouTubeVideoUpload = async (
	companyId: string,
	videoData: YouTubeVideoData
): Promise<VideoResponse> =>
{
	try
	{
		// Basic validation
		if (!videoData.videoUrl || !videoData.videoId || !videoData.thumbnailUrl)
		{
			const errorMessage = 'Missing required YouTube video information';

			throw new Error(errorMessage);
		}

		// Create API payload
		const videoPayload: CreateVideoPayload = {
			sourceType : 'embed_link', // for youtube videos 'embed_link'
			videos     : [ {
				title       : videoData.title || `YouTube Video - ${videoData.videoId}`,
				description : videoData.description || '',
				url         : videoData.videoUrl,
				fileType    : 'mp4', // Using valid enum value for server validation
				fileSize    : 0, // YouTube videos don't have a file size since they're not uploaded
				thumbnail   : {
					url : videoData.thumbnailUrl
				},
				platform : 'youtube', // Add platform field to identify it as YouTube
				videoId  : videoData.videoId // Store the YouTube video ID for reference

			} ]
		};

		// Add optional fields if provided
		if (videoData.categoryIds)
		{
			videoPayload.categoryIds = videoData.categoryIds;
		}

		// if (videoData.visibility)
		// {
		// 	videoPayload.visibility = videoData.visibility;
		// }

		if (videoData.tags && videoData.tags.length > 0)
		{
			videoPayload.tags = videoData.tags;
		}

		// Add access control options if provided
		if (videoData.allowDownload !== undefined)
		{
			videoPayload.allowDownload = videoData.allowDownload;
		}

		if (videoData.allowShare !== undefined)
		{
			videoPayload.allowShare = videoData.allowShare;
		}

		// if (videoData.accessControl)
		// {
		// 	videoPayload.accessControl = videoData.accessControl;
		// }

		// Make the API call
		const response = await createVideoCollection(companyId, videoPayload);

		return response;
	}
	catch (error)
	{
		console.error('Error adding YouTube video:', error);

		// Provide more specific error messages based on the error type
		let errorMessage = 'Failed to add YouTube video. Please try again.';

		if (error instanceof Error)
		{
			if (error.message.includes('network'))
			{
				errorMessage = 'Network error. Please check your connection and try again.';
			}
			else if (error.message.includes('timeout'))
			{
				errorMessage = 'Request timed out. Please try again.';
			}
			else if (error.message.includes('permission'))
			{
				errorMessage = 'Permission denied. You may not have access to add videos.';
			}
			else if (error.message.includes('storage'))
			{
				errorMessage = 'Storage error. Please contact support.';
			}
		}

		toast.error(errorMessage);
		throw error;
	}
};

/**
 * Handles the complete video upload process including thumbnail generation, S3 uploads,
 * and API call to create the video.
 *
 * @param file - The video file to upload
 * @param companyId - The company ID
 * @param options - Additional options like visibility, categoryIds, etc.
 * @returns Promise with the created video data
 */
export const handleVideoUpload = async (
	file: File,
	companyId: string,
	source: string,
	options?: VideoUploadOptions
) =>
{
	// Validate the file first
	const validation = validateVideoFile(file);

	if (!validation.isValid)
	{
		toast.error(validation.errorMessage);
		throw new Error(validation.errorMessage);
	}

	try
	{
		// Show an initial toast for starting the upload
		// const toastId = toast.info('Preparing video upload...', { autoClose: false });

		// Step 1: Generate thumbnail from video
		let thumbnailResult: ThumbnailGenerationResult;

		try
		{
			thumbnailResult = await generateThumbnailFromVideo(file) as ThumbnailGenerationResult;
			// toast.update(toastId, {
			// 	render    : 'Thumbnail generated, uploading content...',
			// 	autoClose : false
			// });
		}
		catch (error)
		{
			console.error('Error generating thumbnail:', error);
			// Use a default thumbnail if generation fails
			const blob = new Blob([ '' ], { type: 'image/jpeg' });

			thumbnailResult = {
				thumbnailFile : new File([ blob ], 'default-thumbnail.jpg', { type: 'image/jpeg' })
			};
		}

		// Step 2: Upload thumbnail to S3
		const customPrefix = { public: `${companyId}/resource/` };
		const thumbnailUrl = await configureStore(thumbnailResult.thumbnailFile, customPrefix);

		// Step 3: Upload video to S3 with progress updates
		const uploadResult = await newNewsFeedUploadFiles(
			[ file ],
			`${companyId}/resource`);

		const { url, type, size } = uploadResult[0];
		const fileType = type.split('/')[1];

		// Step 4: Create API payload
		const videoPayload: CreateVideoPayload = {
			sourceType : source as 'system' | 'upload' | 'embed_link' | 'media_drive' ?? 'system',
			videos     : [ {
				title       : options?.title || file.name.replace(/\.[^/.]+$/, ''),
				description : options?.description || '',
				url,
				fileType,
				fileSize    : size || file.size,
				thumbnail   : {
					url : thumbnailUrl
				},
				duration : Number(((await getVideoDuration(uploadResult[0])) as number ?? 0) / 1000)
			} ]
		};

		// Add optional fields if provided
		if (options?.categoryIds)
		{
			videoPayload.categoryIds = options.categoryIds;
		}

		// if (options?.visibility)
		// {
		// 	videoPayload.visibility = options.visibility;
		// }

		if (options?.tags && options.tags.length > 0)
		{
			videoPayload.tags = options.tags;
		}

		// Add access control options if provided
		if (options?.allowDownload !== undefined)
		{
			videoPayload.allowDownload = options.allowDownload;
		}

		if (options?.allowShare !== undefined)
		{
			videoPayload.allowShare = options.allowShare;
		}

		// if (options?.accessControl)
		// {
		// 	videoPayload.accessControl = options.accessControl;
		// }

		// Step 5: Call API to create video entry
		// toast.update(toastId, {
		// 	render    : 'Processing video...',
		// 	autoClose : false
		// });

		const response = await createVideoCollection(companyId, videoPayload);

		// Complete the toast
		// toast.success('Video uploaded successfully!');
		// toast.update(toastId, {
		// 	render    : 'Video uploaded successfully!',
		// 	type      : toast.TYPE.SUCCESS,
		// 	autoClose : 3000
		// });

		return response;
	}
	catch (error)
	{
		// console.error('Error uploading video:', error);

		// Provide more specific error messages based on the error type
		let errorMessage = 'Failed to upload video. Please try again.';

		if (error instanceof Error)
		{
			if (error.message.includes('network'))
			{
				errorMessage = 'Network error. Please check your connection and try again.';
			}
			else if (error.message.includes('timeout'))
			{
				errorMessage = 'Upload timed out. Please try again with a smaller file.';
			}
			else if (error.message.includes('permission'))
			{
				errorMessage = 'Permission denied. You may not have access to upload videos.';
			}
			else if (error.message.includes('storage'))
			{
				errorMessage = 'Storage error. Please contact support.';
			}
		}

		toast.error(errorMessage);
		throw error;
	}
};

/**
 * Internal helper to update a video without showing toasts
 * (Used by handleMultipleVideoUpdates to avoid duplicate toasts)
 */
const updateVideoSilent = async (
	videoId: string,
	options: VideoUpdateOptions
): Promise<VideoResponse> =>
{
	// Define all possible top-level update keys
	const topLevelKeys = [
		'categoryIds', 'tags',
		'allowDownload', 'allowShare'
	];

	// Define video-specific detail keys
	const videoDetailKeys = [
		'title', 'description', 'url', 'fileType', 'fileSize',
		'playlists', 'duration', 'status', 'scheduledPublishDate',
		'scheduledPublishTime', 'scheduledDateTime', 'thumbnail'
	];

	// Build top-level properties
	const updatePayload: Partial<CreateVideoPayload> = {
		sourceType : 'system',
		...topLevelKeys.reduce((acc: any, key) =>
		{
			if (options[key as keyof VideoUpdateOptions] !== undefined && options[key as keyof VideoUpdateOptions] !== '')
			{
				acc[key] = options[key as keyof VideoUpdateOptions];
			}

			return acc;
		}, {})
	};

	// Build video details object with provided values
	const videoDetails = videoDetailKeys.reduce((acc: any, key) =>
	{
		if (options[key as keyof VideoUpdateOptions] !== undefined && options[key as keyof VideoUpdateOptions] !== '')
		{
			acc[key] = options[key as keyof VideoUpdateOptions];
		}

		return acc;
	}, {});

	// Handle thumbnail specially (due to nested structure)
	if (options.thumbnail)
	{
		videoDetails.thumbnail = {
			url       : options.thumbnail?.url,
			canEdit   : options.thumbnail?.canEdit,
			canDelete : options.thumbnail?.canDelete
		};
	}

	// Add video details to payload if there are updates
	if (Object.keys(videoDetails).length > 0)
	{
		updatePayload.videos = [ videoDetails ];
	}

	// Call API to update video without toasts
	return await updateVideo(videoId, updatePayload);
};

/**
 * Handles updating multiple videos at once with the same data
 * 
 * @param companyId - The company ID
 * @param videoIds - Array of video IDs to update
 * @param updatedData - The data to apply to all videos
 * @returns Promise with array of responses
 */
export const handleMultipleVideoUpdates = async (
	companyId: string,
	videos: string[],
	updatedData: any,
	existingDataArray: any[] | any // Allow both array and single object for backward compatibility
) =>
{
	if (!videos || videos.length === 0)
	{
		throw new Error('No video IDs provided for update');
	}

	try
	{
		// Show an initial toast for starting the update
		const isBatchUpdate = videos.length > 1;
		// const toastId = toast.info(
		// 	isBatchUpdate
		// 		? `Updating ${videoIds.length} videos...`
		// 		: 'Updating video...',
		// 	{ autoClose: false }
		// );

		// Convert single object to array if needed
		const existingDataAsArray = Array.isArray(existingDataArray)
			? existingDataArray
			: existingDataArray ? [ existingDataArray ] : [];

		// Process each video update as a separate operation
		const updatePromises = videos.map((videoId, index) =>
		{
			// Get the corresponding existing data for this video
			const existingData = existingDataAsArray[index];

			const isBulk = videos.length > 1;

			// Array merging logic only for bulk
			const mergedPlaylists = isBulk && existingData
				? [
					...(existingData.playlists || []),
					...(updatedData.playlists || [])
				].reduce((acc, item) =>
				{
					if (!acc.find((p) => p.playlistId === item.playlistId))
					{
						acc.push(item);
					}

					return acc;
				}, [])
				: updatedData.playlists;

			const mergedCategories = isBulk
			  ? Array.from(new Set([
				  ...(existingData?.categoryIds || existingData.categories || []),
				  ...(updatedData.categoryIds || updatedData.categories || [])
				]))
			  : updatedData.categoryIds || updatedData.categories;

			const mergedTags = isBulk && existingData
			  ? Array.from(new Set([
				  ...(existingData.tags || []),
				  ...(updatedData.tags || [])
				]))
			  : updatedData.tags;

			const options: any = {
			  videoId,

			  // Use updated values if present, fallback to existing (for bulk)
			  title         : updatedData.title ?? (isBulk && existingData ? existingData.title : undefined),
			  description   : updatedData.description ?? (isBulk && existingData ? existingData.description : undefined),
			  url           : updatedData.url ?? (isBulk && existingData ? existingData.url : undefined),
			  thumbnail     : updatedData.thumbnail ?? (isBulk && existingData ? existingData.thumbnail : undefined),
			  allowDownload : updatedData.allowDownload ?? (isBulk && existingData ? existingData.allowDownload : undefined),
			  allowShare    : updatedData.allowShare ?? (isBulk && existingData ? existingData.accessControl : undefined),
			  status        : updatedData.status ?? (isBulk && existingData ? existingData.status : undefined),
			  quality       : updatedData.quality ?? (isBulk && existingData ? existingData.quality : undefined),
			  publishDate   : updatedData.publishDate ?? (isBulk && existingData ? existingData.publishDate : undefined),
			  duration      : updatedData.duration ?? (isBulk && existingData ? existingData.duration : undefined),

				//   categories  : mergedCategories,
				tags : mergedTags

			};

			// Only include playlists if we're actually updating playlists
			if (updatedData.playlists !== undefined)
			{
				options.playlists = mergedPlaylists;
			}

			if (updatedData?.categoryIds?.length > 0 && updatedData?.categoryIds?.[0] !== existingData?.categoryIds?.[0])
			{
				options.categoryIds = updatedData.categoryIds;
			}

			// Clean up undefined fields
			Object.keys(options).forEach((key) =>
			{
			  if (options[key as keyof typeof options] === undefined)
				{
					delete options[key as keyof typeof options];
			  }
			});

			console.log(options, '---final options');

			return updateVideoSilent(videoId, options); // If making API call
		  });

		// Wait for all updates to complete
		const responses = await Promise.all(updatePromises);

		const refreshEvent = new CustomEvent('contentStatusChanged', {
			detail : {
				contentId   : videos,
				contentType : 'Videos',
				status      : 'updated'
			}
		});

		window.dispatchEvent(refreshEvent);

		// Show success message
		toast.success(
			isBatchUpdate
				? `${videos.length} videos updated successfully!`
				: 'Video updated successfully!'
		);

		return responses;
	}
	catch (error)
	{
		// console.error('Error updating videos:', error);

		// Provide error message
		const errorMessage = videos.length > 1
			? `Failed to update some or all of the ${videos.length} videos`
			: 'Failed to update video';

		toast.error(errorMessage);
		throw error;
	}
};

/**
 * Handles updating an existing video with new details
 * 
 * @param companyId - The company ID
 * @param options - Update options including videoId and fields to update
 * @returns Promise with the updated video data
 */
export const handleVideoUpdate = async (
	companyId: string,
	options: VideoUpdateOptions
): Promise<VideoResponse> =>
{
	try
	{
	  // Validate options and videoId
	  if (!options || !options.videoId)
		{
			throw new Error('videoId is required');
	  }

	  // Initialize the update payload without the videos array
	  const updatePayload: Partial<CreateVideoPayload> = {
			sourceType : 'system'
	  };

	  // Add optional fields if provided
	  // if (options.visibility)
		// {
		// 	updatePayload.visibility = options.visibility;
		// }

	  if (options.categoryIds)
		{
			updatePayload.categoryIds = options.categoryIds;
	  }

	  if (options.tags)
		{
			updatePayload.tags = options.tags;
	  }

	  // Add access control options if provided
	  if (options.allowDownload !== undefined)
		{
			updatePayload.allowDownload = options.allowDownload;
	  }

	  if (options.allowShare !== undefined)
		{
			updatePayload.allowShare = options.allowShare;
	  }

	  // if (options.accessControl)
		// {
		// 	updatePayload.accessControl = options.accessControl;
		// }

	  // Create video details object with provided values
	  const newVideoDetails: any = {
			title       : options.title,
			description : options.description
	  };

	  // Add URL, fileType, and fileSize if provided
	  if (options.url)
		{
			newVideoDetails.url = options.url;
	  }

	  if (options.fileType)
		{
			newVideoDetails.fileType = options.fileType;
	  }

	  if (options.fileSize)
		{
			newVideoDetails.fileSize = options.fileSize;
	  }

	  // Important: Add playlists if provided
	  if (options.playlists)
		{
			newVideoDetails.playlists = options.playlists;
	  }

	  // Add thumbnail if provided
	  if (options.thumbnail)
		{
			newVideoDetails.thumbnail = {
		  url       : options.thumbnail?.url,
		  canEdit   : options.thumbnail?.canEdit,
				canDelete : options.thumbnail?.canDelete
			};
	  }

	  // Add status if provided
	  if (options.status)
		{
			newVideoDetails.status = options.status;
	  }

	  // Add scheduling details if provided
	  if (options.scheduledPublishDate)
		{
			newVideoDetails.scheduledPublishDate = options.scheduledPublishDate;
	  }

	  if (options.scheduledPublishTime)
		{
			newVideoDetails.scheduledPublishTime = options.scheduledPublishTime;
	  }

	  if (options.scheduledDateTime)
		{
			newVideoDetails.scheduledDateTime = options.scheduledDateTime;
	  }

	  // Add video details to payload if there are updates to video-specific fields
	  if (Object.keys(newVideoDetails).length > 0)
		{
			updatePayload.videos = [ newVideoDetails ];
	  }
		else if (options.playlists)
		{
		// If we're updating playlists, make sure the videos array is included
			updatePayload.videos = [ { playlists: options.playlists } as any ];
	  }

	  // Call API to update video
	  const response = await updateVideo(options.videoId, updatePayload);

	  // Return the response
	  return response;
	}
	catch (error)
	{
	  console.error('Error updating video:', error);

	  // Provide more specific error messages based on the error type
	  let errorMessage = 'Failed to update video. Please try again.';

	  if (error instanceof Error)
		{
			if (error.message.includes('network'))
			{
		  errorMessage = 'Network error. Please check your connection and try again.';
			}
			else if (error.message.includes('timeout'))
			{
		  errorMessage = 'Update timed out. Please try again.';
			}
			else if (error.message.includes('permission'))
			{
		  errorMessage = 'Permission denied. You may not have access to update this video.';
			}
			else if (error.message.includes('storage'))
			{
		  errorMessage = 'Storage error. Please contact support.';
			}
	  }

	  // Optionally, display a toast notification with the error message
	  // showToast(errorMessage);

	  // Rethrow the error to propagate it
	  throw new Error(errorMessage);
	}
};

/**
 * Uploads a video file to S3
 * @param files - Array of files to upload
 * @param path - Path for S3 storage
 * @returns Promise with upload result
 */
/**
 * Uploads a thumbnail to S3
 * @param thumbnailFile - Thumbnail file to upload
 * @param prefix - S3 prefix/path
 * @returns Promise with thumbnail URL
 */
